var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8275 0.477677C20.7853 0.740516 21.5397 1.51497 21.7957 2.49845C22.2609 4.2809 22.2609 8 22.2609 8C22.2609 8 22.2609 11.719 21.7957 13.5015C21.5397 14.485 20.7853 15.2595 19.8275 15.5225C18.0916 16 11.1304 16 11.1304 16C11.1304 16 4.16923 16 2.43327 15.5225C1.47542 15.2595 0.721075 14.485 0.465075 13.5015C0 11.719 0 8 0 8C0 8 0 4.2809 0.465075 2.49845C0.721075 1.51497 1.47542 0.740516 2.43327 0.477677C4.16923 0 11.1304 0 11.1304 0C11.1304 0 18.0916 0 19.8275 0.477677ZM9.04297 4.86957V11.8261L14.6082 8.34796L9.04297 4.86957Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.d6c38cc1b4e3a87a49ccb98d03f34b31.svg";
export { ForwardRef as ReactComponent };